import validationMessagesEs from 'vee-validate/dist/locale/es';
import validationMessagesEn from 'vee-validate/dist/locale/en';
import validationMessagesFr from 'vee-validate/dist/locale/fr';
import validationMessagesIt from 'vee-validate/dist/locale/it';

const dictionary = {
  es: validationMessagesEs,
  en: validationMessagesEn,
  fr: validationMessagesFr,
  it: validationMessagesIt,
};


export default dictionary;
